/**
 * @generated SignedSource<<8669eb126b2b8f29887a1c69bc0b7a73>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
export type PullRequestState = "CLOSED" | "MERGED" | "OPEN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type PullRequestAndBranchPickerPullRequest$data = {
  readonly __typename: "PullRequest";
  readonly createdAt: string;
  readonly id: string;
  readonly isDraft: boolean;
  readonly isInMergeQueue: boolean;
  readonly number: number;
  readonly repository: {
    readonly id: string;
    readonly name: string;
    readonly nameWithOwner: string;
    readonly owner: {
      readonly __typename: string;
      readonly id: string;
      readonly login: string;
    };
  };
  readonly state: PullRequestState;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "PullRequestAndBranchPickerPullRequest";
};
export type PullRequestAndBranchPickerPullRequest$key = {
  readonly " $data"?: PullRequestAndBranchPickerPullRequest$data;
  readonly " $fragmentSpreads": FragmentRefs<"PullRequestAndBranchPickerPullRequest">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "PullRequestAndBranchPickerPullRequest"
};

(node as any).hash = "135ebcc3f426d6b82c620b752a966880";

export default node;
